<script lang="ts">
	//Formatters
	import { format } from 'svelte-i18n';

	//Design system components
	import { Container, Select, Text } from '@Shelly/shelly-design-system';

	export let editableObject;

	let deviceActions = Object.assign({}, { ...editableObject });

	const options = deviceActions.options; //array of options for select holder
	let condition = deviceActions.condition; //default state

	$: icon = condition === options[0] ? 'fas fa-door-open' : 'fas fa-temperature-high';
	/**
	 * @function changeCategory update store with
	 * @param e which is selected event object
	 */
	const changeCategory = (e) => {
		condition = e.detail;
		deviceActions.condition = condition;
		deviceActions.selectedDevices = [];
		deviceActions.selectedAction = undefined;
		deviceActions.disabled = true;
		editableObject = deviceActions;
	};
</script>

<Container padding="0">
	<Text class="mb-l">
		{$format('actions_conditions_description') || 'Select which condition will trigger action:'}
	</Text>
	<Select
		aria-label={$format('select_condition', { default: 'Select condition' })}
		{icon}
		{options}
		value={condition}
		on:change={changeCategory}
		id="select-ye2dux7"
	/>
</Container>
